import { LocationSearchInput } from 'elements/minute/sidebar/sidebarComponents/complex/LocationSearchInput';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { motion } from 'framer-motion';
import { useCreateWorldMarkerV2 } from 'hooks/marker/v2/useCreateWorldMarkerV2';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { useContext } from 'react';
import { ICoordinates } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const IconToolSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const createMarkers = useCreateWorldMarkerV2();

    function createNewMarer(coordinates: ICoordinates) {
        createMarkers.createIcon(coordinates.lat, coordinates.lng);
    }

    return (
        <motion.div {...ANIMATION_APPEAR}>
            <S_IconToolSidebar className={props.className}>
                <SidebarSubsection
                    title={Localization.ADDRESS_SEARCH}
                    icon={{ iconName: 'location-dot' }}
                >
                    <SidebarContent>
                        <LocationSearchInput
                            onLocationSelected={({ lat, lng }) => {
                                createNewMarer({ lat, lng });
                                ctxEdit?.mapRef.current?.flyTo({
                                    center: [lng, lat],
                                    zoom: 13
                                });
                            }}
                        />
                    </SidebarContent>
                </SidebarSubsection>
            </S_IconToolSidebar>
        </motion.div>
    );
};

const S_IconToolSidebar = styled.div`
    width: 100%;
`;
